<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.389 13.063V20.5H4.61v-7.438M5.35 3.5h13.3l2.85 4.958v1.48a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-1.48L5.35 3.5Zm3.99 0h5.32l1.14 4.958v2.48H8.2v-2.48L9.34 3.5Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
